videojs.addLanguage('ru', {
 
});